import React, { FC, useContext, useState } from 'react';
import { BdsButton, BdsAlert, BdsAlertHeader, BdsAlertBody, BdsAlertActions } from 'blip-ds/dist/blip-ds-react';
import '../../styles.scss';
import { useContentLocalizer } from '../../../../hooks/useContentLocalizer';
import { localization } from './localization';
import MtlsContext from '../../../../contexts/MtlsContext';
import { showToast } from '../../../../api/CommonApi';

const RemoveCertificate: FC = () => {
  const {
    removeCertificateAlert,
    closeRemoveCertificateAlert,
    mtlsCertificateApi,
    tenantId,
    setCertificateUpdatedProps,
    certificateUpdatedProps,
    setMtlsCertificate,
    mtlsCertificate,
  } = useContext(MtlsContext);
  const content = useContentLocalizer(localization);
  const [isLoading, setIsLoading] = useState(false);

  const certificateAlert = document.getElementById('remove-certificate-alert');
  const shadowRoot = certificateAlert?.shadowRoot?.querySelector('.alert__dialog .alert');
  shadowRoot?.setAttribute('style', 'position:relative;margin:auto;top: 40%;');

  const handleDeleteCertificate = async () => {
    try {
      setIsLoading(true);
      await mtlsCertificateApi.deleteMtlsCertificate(tenantId, certificateUpdatedProps.certificateId);
      const responseStatus = mtlsCertificateApi.getStatus();
      if (responseStatus == 'success') {
        closeRemoveCertificateAlert();
        mtlsCertificate.splice(
          mtlsCertificate.findIndex((e) => e.id === certificateUpdatedProps.certificateId),
          1,
        );
        setMtlsCertificate(mtlsCertificate);
        setCertificateUpdatedProps({
          ...certificateUpdatedProps,
          certificateUpdated: !certificateUpdatedProps.certificateUpdated,
        });
        showToast({
          type: 'success',
          message: content.successRemovedCertificate,
        });
      } else {
        showToast({
          type: 'danger',
          message: content.failRemoveCertificate,
        });
      }
    } catch (error) {
      showToast({
        type: 'danger',
        message: content.failRemoveCertificate,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseCertificateAlert = () => {
    if (isLoading) return;
    closeRemoveCertificateAlert();
  };

  return (
    <BdsAlert id="remove-certificate-alert" open={removeCertificateAlert}>
      <BdsAlertHeader variant="warning" icon="warning">
        {content.caution}
      </BdsAlertHeader>
      <BdsAlertBody>{content.confirmMessage}</BdsAlertBody>
      <BdsAlertActions>
        <BdsButton disabled={isLoading} variant="secondary" onClick={handleCloseCertificateAlert}>
          {content.cancel}
        </BdsButton>
        <BdsButton bdsLoading={isLoading} variant="secondary" onClick={handleDeleteCertificate}>
          {content.disable}
        </BdsButton>
      </BdsAlertActions>
    </BdsAlert>
  );
};

export default RemoveCertificate;
